import React from "react";
import { Link } from "react-router-dom";
import { styled } from "styled-components";

import iconBackSrc from "./icon-back.svg";

const BackLinkIcon = styled.span`
  background: ${(props) => props.theme.colours.blue[900]};
  color: ${(props) => props.theme.colours.white};
  border-radius: 2rem;
  display: flex;
  width: 2rem;
  height: 2rem;
  justify-content: center;
  align-items: center;
  transition: all 300ms ease-in-out;

  &:hover {
    background: ${(props) => props.theme.colours.blue[700]};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${(props) => props.theme.colours.focus};
  }
`;

export const BackLink: React.FC<{ to?: string; alt?: string }> = ({ to = "../..", alt }) => {
  return (
    <Link to={to} data-testid="back-link">
      <BackLinkIcon>
        <img src={iconBackSrc} alt={alt ?? "Go back"} />
      </BackLinkIcon>
    </Link>
  );
};
